import React, { Component } from 'react';
import add_box from '../images/add_box.svg';
import deleteImg from '../images/delete.svg';
import close_black from '../images/close-black.svg';
import Modal from 'react-modal';
import * as uuid from "uuid";
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import "../styles/Location.scss";
import { Fragment } from 'react';
import loader from '../images/loader.gif';
import '../styles/CommonStyle.scss';
import { Capital, Receivable, Drawing, AccountType, ParentAccount } from '../enum/account-entity';
import { Agency } from '../enum/agency-entity';
import spinner from '../images/spinner.png';
import { withTranslation } from 'react-i18next';
import SuccessAlert from './SuccessAlert';
import ErrorAlert from './ErrorAlert';
import { getLocation, createLocation, deleteLocation, updateLocation, getLocationByGroupGuid } from '../services/branch-service';
import { getCountryData } from '../services/country-service';
import { getAccountData } from '../services/account-service';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';
import { getTenantLanguages, insertIntoHistoryTbl, updateTenant } from '../services/tenant-identity-service';
import { getCurrencyData } from '../services/currency-service';
import { translateToTargetLanguage, getMessages, getFieldMessages, getValueMessages, getFieldAndValueMessages } from '../services/language-service';
import { Message } from '../enum/message';
import { FieldName } from "../enum/fieldName";
import { MessageType } from "../enum/message-type";
import { getClosingPeriod } from '../services/financial-period-service';

Modal.setAppElement("#root");

class Location extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            isConfirmModalOpen: false,
            isLoading: true,
            OfficeName: '',
            OfficeShortName: '',
            CountryGuid: '',
            CurrencyGuid: '',
            LanguageGuid: '',
            locationArr: [],
            countryArr: [],
            currencyArr: [],
            alert_type: '',
            alert_message: '',
            multiLanguageTranslatedArr: [],
            //accountArr: [],
            languageArr: [],
            confirmationMessage: '',
            confirmationTitle: '',
            selectedLocation: {},
            confirmationRequestedFunction: '',
            selectedCheckBoxValue: false
        }

        this.isComponentMounted = false;
    }

    componentDidMount = async () => {
        this.isComponentMounted = true;
        let languageGuid = localStorage.getItem('languageGuid');
        if (this.isComponentMounted) {
            this.setState({ LanguageGuid: languageGuid });
            await this.getBranch();
            await this.getCountry();
            await this.SearchCurrency();
            //await this.getAccount();
            await this.getAllLanguages();
        }
    }

    componentWillUnmount() {
        this.isComponentMounted = false;
    }

    SearchCurrency = async () => {
        let currencyArr = [];

        try {
            let response = await getCurrencyData();
            let currencyList = response.data.SearchCurrency;
            let currencyResult = currencyList.map(value => {
                return { value: value.LanguageGroupGuid, display: value.Name, LanguageGuid: value.LanguageGuid, symbol: value.Symbol }
            });

            currencyArr = [{ value: '', display: 'Select Currency' }].concat(currencyResult);

            if (this.isComponentMounted) {
                this.setState({
                    currencyArr: currencyArr
                });
            }
        } catch (error) {
            console.log('SearchCurrency error', error);
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    getCountry = async () => {
        let countryArr = [];

        try {
            let response = await getCountryData();
            let countryList = response.data.getCountry;
            let countryResult = countryList.map(value => {
                return { value: value.GroupGuid, display: value.Name, LanguageGuid: value.LanguageGuid }
            });
            countryArr = [{ value: '', display: 'Select Country' }].concat(countryResult);
            if (this.isComponentMounted) {
                this.setState({ countryArr: countryArr });
            }
        } catch (error) {
            console.log('getCountry error', error);
        }
    }

    getAccount = async () => {
        try {
            let result = await getAccountData();
            let accountList = result.data.SearchAccount;
            if (this.isComponentMounted) {
                this.setState({ accountArr: accountList });
            }

        } catch (error) {
            console.log('getAccount error', error);
        }
    }

    getBranch = async () => {
        try {
            let response = await getLocation();
            if (this.isComponentMounted) {
                this.setState({ locationArr: response.data.getBranch });
            }
        } catch (error) {
            console.log('getBranch error', error);
        }

        this.setState({ isLoading: false });
    }

    handleModalClose = event => {
        this.setState({ isModalOpen: false })
    }

    handleModalOpen = event => {
        this.setState({ isModalOpen: true })
    }

    handleConfirmModalClose = async (event) => {
        this.setState({ locationArr: [] });
        await this.getBranch();
        this.setState({ isConfirmModalOpen: false });
    }

    handleConfirmModalOpen = event => {
        this.setState({ isConfirmModalOpen: true })
    }

    //#region delete,activate,deactivate location function
    getLocationByGroupGuid = async (locationGroupGuid) => {
        try {
            let response = await getLocationByGroupGuid(locationGroupGuid);
            return response.data.getBranch;
        } catch (err) {
            console.log('getLocationByGroupGuid', err);
        }
    }

    activateDeactivateSeletedLocation = async (event, item) => {
        this.setState({ isLoading: true });
        let checkboxValue = event.target.checked;
        await this.setState({ 'selectedCheckBoxValue': checkboxValue });
        await this.clearAlertType();
        await this.clearConfirmaionData();
        let requestedFunction = checkboxValue ? 'ACTIVATE_LOCATION' : 'DEACTIVATE_LOCATION';
        let messageGuid = checkboxValue ? Message.ACTIVATE_CONFIRMATION_MESSAGE : Message.DEACTIVATE_CONFIRMATION_MESSAGE;
        let title = checkboxValue ? 'Activate' : 'Deactivate';
        let locationObj = item;
        let confirmationTitle = title;
        let fieldName = { F1: FieldName.LOCATION };
        let valueFields = { V1: item.OfficeName };
        let confirmationMessage = await getFieldAndValueMessages(messageGuid, fieldName, valueFields);
        await this.setConfirmaionData(confirmationTitle, confirmationMessage, requestedFunction, locationObj);
        this.setState({ isLoading: false });
        await this.handleConfirmModalOpen();
    }

    activateDeactivateLocation = async (selectedCheckBoxValue, item) => {
        try {
            this.setState({ isLoading: true });
            let langugeGuid = localStorage.getItem('languageGuid');
            let fieldName = { F1: FieldName.LOCATION };
            let messageGuid = selectedCheckBoxValue ? Message.ACTIVATED_MESSAGE : Message.DEACTIVATED_MESSAGE;
            let createdLocationList = this.state.locationArr;

            let locationList = await this.getLocationByGroupGuid(item.GroupGuid);

            let updateArray = JSON.parse(JSON.stringify(locationList)).map(({ Country, Currency, ...rest }) => ({ ...rest }));

            updateArray.forEach(agency => {
                agency.IsActive = selectedCheckBoxValue;
            });

            let inputData = {
                AgencyList: updateArray
            }

            updateLocation(inputData)
                .then(async (response) => {
                    let newBranch = JSON.parse(JSON.stringify(response.data.updateBranch));
                    newBranch = newBranch.filter((obj) => {
                        return obj.LanguageGuid.toLowerCase() === langugeGuid.toLowerCase()
                    })

                    let newBranchObj = newBranch[0];

                    let objIndex = createdLocationList.findIndex((obj => obj.GroupGuid.toLowerCase() == newBranchObj.GroupGuid.toLowerCase()));
                    createdLocationList[objIndex] = newBranchObj;
                    this.setState({ 'locationArr': createdLocationList });
                    let validationMessage = await getFieldMessages(messageGuid, fieldName);
                    this.setState({ alert_type: MessageType.SUCCESS });
                    this.setState({ alert_message: validationMessage });
                    this.setState({ isConfirmModalOpen: false, isLoading: false });
                })
                .catch(error => {
                    this.setState({ isLoading: false, isConfirmModalOpen: false });
                    let errorObj = JSON.parse(JSON.stringify(error));
                    let errMessage = errorObj["errors"][0].message;
                    this.setState({ alert_type: MessageType.ERROR, alert_message: errMessage });
                });

        } catch (err) {
            console.log('activateDeactivateLocation', err);
        }
    }

    clearConfirmaionData = () => {
        this.setState({ 'confirmationTitle': '', 'confirmationMessage': '', 'confirmationRequestedFunction': '', 'selectedLocation': {} });
    }

    setConfirmaionData = (title, message, requestedFunction, locationObj) => {
        this.setState({ 'confirmationTitle': title, 'confirmationMessage': message, 'confirmationRequestedFunction': requestedFunction, 'selectedLocation': locationObj });
    }

    deletedSelectedLocation = async (event, item) => {
        event.preventDefault();
        this.setState({ isLoading: true });
        await this.clearConfirmaionData();
        let requestedFunction = 'DELETE_LOCATION';
        let locationObj = item;
        let confirmationTitle = 'Delete';
        let fieldName = { F1: FieldName.LOCATION };
        let valueFields = { V1: item.OfficeName };
        let confirmationMessage = await getFieldAndValueMessages(Message.DELETE_CONFIRMATION_MESSAGE, fieldName, valueFields);
        await this.setConfirmaionData(confirmationTitle, confirmationMessage, requestedFunction, locationObj);
        this.setState({ isLoading: false });
        await this.handleConfirmModalOpen();
    }

    confirmButtonClicked = (event) => {
        event.preventDefault();
        this.setState({ isLoading: true });
        const { confirmationRequestedFunction, selectedLocation, selectedCheckBoxValue } = this.state;

        if (confirmationRequestedFunction === 'DELETE_LOCATION') {
            this.deleteBranch(selectedLocation);
        } else if (confirmationRequestedFunction === 'ACTIVATE_LOCATION') {
            this.activateDeactivateLocation(selectedCheckBoxValue, selectedLocation);
        } else if (confirmationRequestedFunction === 'DEACTIVATE_LOCATION') {
            this.activateDeactivateLocation(selectedCheckBoxValue, selectedLocation);
        }
    }

    deleteBranch = async (item) => {
        this.clearAlertType();
        let deleteItem = [];
        let tenantResult = this.props.auth.tenantResult;
        this.setState({ isLoading: true });

        let fianacialPeriodList = await this.getClosingPeriod(item.GroupGuid);

        if (fianacialPeriodList.length > 1) {
            this.setState({ isLoading: false });
            this.setState({ isConfirmModalOpen: false });
            let validationMessage = await getMessages(Message.AGENCY_DELETE_FINANCIAL_PERIOD_REFERENCE);
            this.setState({ alert_type: MessageType.ERROR });
            this.setState({ alert_message: validationMessage });
        } else {
            deleteItem.push(item);
            deleteItem = deleteItem.map(({ Country, Currency, ...rest }) => ({ ...rest }));

            let inputData = {
                AgencyList: deleteItem
            }

            deleteLocation(inputData)
                .then(async (response) => {
                    tenantResult.locationCount = tenantResult.locationCount - 1;

                    //Insert into history table.
                    let historyData = {
                        "tenantGuid": tenantResult.tenantGuid,
                        "userGuid": this.props.auth.tenantUserGuid,
                        "masterId": 2,
                        "count": -1,
                        "licenseTypeGuid": ''
                    }

                    await insertIntoHistoryTbl(historyData);

                    //Update Language Count in Tenant table.
                    let tenantUpdateData = {
                        "tenantGuid": tenantResult.tenantGuid,
                        "companyName": tenantResult.companyName,
                        "userPoolName": tenantResult.userPoolName,
                        "identityPoolId": tenantResult.identityPoolId,
                        "clientId": tenantResult.clientId,
                        "region": tenantResult.region,
                        "isPurchase": tenantResult.isPurchase,
                        "locationCount": tenantResult.locationCount,
                        "productCount": tenantResult.productCount,
                        "webLicenseCount": tenantResult.webLicenseCount,
                        "pdaLicenseCount": tenantResult.pdaLicenseCount,
                        "userPoolId": tenantResult.userPoolId,
                        "languageCount": tenantResult.languageCount
                    }

                    await updateTenant(tenantUpdateData);


                    let filteredArr = this.state.locationArr.filter(function (value, index, arr) {
                        return value.GroupGuid.toLowerCase() !== item.GroupGuid.toLowerCase();
                    });

                    this.setState({ locationArr: filteredArr });
                    this.setState({ isLoading: false });
                    this.setState({ isConfirmModalOpen: false });
                    this.setState({ alert_type: MessageType.ERROR });
                    this.setState({ alert_message: 'Location deleted successfully' });
                })
                .catch(error => {
                    this.setState({ isLoading: true });
                    this.setState({ isConfirmModalOpen: false });
                    let errMessage = error.errors[0].message;
                    this.setState({ alert_type: MessageType.ERROR });
                    this.setState({ alert_message: errMessage });
                });
        }
    }

    //#endregion

    handleSubmit = async (event) => {
        this.setState({ isLoading: true });
        event.preventDefault();
        this.clearAlertType();

        let objForTranslation = {};
        let objNotForTranslation = {};
        let translateObjArr = [];
        let multiLanguageTranslatedArr = [];

        let agencyObj = Object.create(Agency);
        agencyObj.CountryGuid = this.state.CountryGuid;
        agencyObj.CurrencyGuid = this.state.CurrencyGuid;
        agencyObj.LanguageGuid = this.state.LanguageGuid;
        agencyObj.OfficeName = this.state.OfficeName;
        agencyObj.OfficeShortName = this.state.OfficeShortName;

        objForTranslation = this.getTranslatingNotTranlatingObj(agencyObj).objForTranslation;
        objNotForTranslation = this.getTranslatingNotTranlatingObj(agencyObj).objNotForTranslation;

        if (Object.values(objForTranslation).length !== 0) {
            translateToTargetLanguage(objForTranslation)
                .then((result) => {
                    translateObjArr = result;
                    multiLanguageTranslatedArr = this.getTranslatedObject(translateObjArr, objNotForTranslation);
                    this.createNewBranch(multiLanguageTranslatedArr);
                })
                .catch((error) => {
                    console.log('error++++++', error);
                    this.setState({ isLoading: false });
                });
        }
    }

    createNewBranch = (multiLanguageTranslatedArr) => {
        let agencyList = [];
        let newLocationArr = [];
        let tenantResult = this.props.auth.tenantResult;
        let langugeGuid = localStorage.getItem('languageGuid');

        newLocationArr = this.state.locationArr;
        agencyList = this.createAccount(multiLanguageTranslatedArr);

        agencyList.forEach(agency => {
            delete agency.CapitalName;
            delete agency.CapitalCode;
            delete agency.CapitalDescription;
            delete agency.ReceivableCode;
            delete agency.ReceivableName;
            delete agency.ReceivableDescription;
            delete agency.DrawingName;
            delete agency.DrawingCode;
            delete agency.DrawingDescription;
            agency.IsBranch = true;
        });

        let inputData = {
            AgencyList: agencyList
        }

        createLocation(inputData)
            .then(async (response) => {
                tenantResult.locationCount = tenantResult.locationCount + 1;
                //Insert into history table.
                let historyData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "userGuid": this.props.auth.tenantUserGuid,
                    "masterId": 2,
                    "count": 1,
                    "licenseTypeGuid": ''
                }

                await insertIntoHistoryTbl(historyData);

                //Update Language Count in Tenant table.
                let tenantUpdateData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "companyName": tenantResult.companyName,
                    "userPoolName": tenantResult.userPoolName,
                    "identityPoolId": tenantResult.identityPoolId,
                    "clientId": tenantResult.clientId,
                    "region": tenantResult.region,
                    "isPurchase": tenantResult.isPurchase,
                    "locationCount": tenantResult.locationCount,
                    "productCount": tenantResult.productCount,
                    "webLicenseCount": tenantResult.webLicenseCount,
                    "pdaLicenseCount": tenantResult.pdaLicenseCount,
                    "userPoolId": tenantResult.userPoolId,
                    "languageCount": tenantResult.languageCount
                }

                await updateTenant(tenantUpdateData);

                let newBranch = JSON.parse(JSON.stringify(response.data.createBranchConfigurator));
                newBranch = newBranch.filter((obj) => {
                    return obj.LanguageGuid.toLowerCase() === langugeGuid.toLowerCase()
                })

                newLocationArr.push(newBranch[0]);
                this.setState({ locationArr: newLocationArr });


                let fieldName = { F1: FieldName.LOCATION };
                let validationMessage = await getFieldMessages(Message.CREATED_MESSAGE, fieldName);
                this.setState({ alert_type: MessageType.SUCCESS });
                this.setState({ alert_message: validationMessage });

                this.setState({ isModalOpen: false });
                this.setState({ isLoading: false });
            })
            .catch(error => {
                this.setState({ isLoading: false });
                this.setState({ isModalOpen: false });
                let errorObj = JSON.parse(JSON.stringify(error));
                let errMessage = errorObj["errors"][0].message;
                this.setState({ alert_type: MessageType.ERROR })
                this.setState({ alert_message: errMessage });
            });

    }

    clearAlertType = () => {
        setTimeout(() => {
            this.setState({ alert_type: '' });
        }, 4000);
    }

    navigate = (e) => {
        this.clearAlertType();
        let locationCount = this.state.locationArr;

        if (locationCount.length > 0) {
            this.props.history.push('/Subscription_Upgrade');
        } else {
            this.setState({ alert_type: MessageType.ERROR });
            this.setState({ alert_message: "Please add Location" });
            e.preventDefault();
        }
    }

    createAccount = (agencyList) => {
        let state = {
            Name: ""
        }

        let account = {
            "Name": "",
            "Description": "",
            "Code": "",
            "Depth": "",
            "PathIndex": "",
            "LocationAccType": "",
            "State": "",
            "LanguageGuid": "",
            "AccTypeId": "",
            "LocationGuid": "",
            "ParentId": "",
            "IsDefault": false,
            "IsActorSpecific": false,
            "IsLocationSpecific": true,
            "IsGroupHeader": false,
            "NumericalHirarchy": 0
        }

        agencyList.forEach(agency => {
            let accountList = [];

            //#region Create Capital Account
            // let accountObj = Object.create(account);
            // accountObj.State = Object.create(state);
            // accountObj.Name = agency.OfficeShortName + ' ' + agency.CapitalName;
            // accountObj.Description = agency.OfficeShortName + ' ' + agency.CapitalDescription;
            // accountObj.Code = agency.OfficeShortName + '_' + agency.CapitalCode;
            // accountObj.LocationAccType = Capital.LocationAccType;
            // accountObj.State.Name = Capital.State;
            // accountObj.LanguageGuid = agency.LanguageGuid;
            // accountObj.LocationGuid = uuid.NIL;
            // accountObj.AccTypeId = AccountType.Capital;
            // accountObj.ParentId = ParentAccount.Capital;
            // accountObj.IsDefault = false;
            // accountObj.IsActorSpecific = false;
            // accountObj.IsLocationSpecific = true;
            // accountObj.IsGroupHeader = false;
            // accountList.push(accountObj);
            //#endregion

            //#region region Create Drawing Account
            //let accountObj = Object.create(account);
            // accountObj = Object.create(account);
            // accountObj.State = Object.create(state);

            // accountObj.Name = agency.OfficeShortName + ' ' + agency.DrawingName;
            // accountObj.Description = agency.OfficeShortName + ' ' + agency.DrawingDescription;
            // accountObj.Code = agency.OfficeShortName + '_' + agency.DrawingCode;
            // accountObj.LocationAccType = Drawing.LocationAccType;
            // accountObj.State.Name = Drawing.State;
            // accountObj.LanguageGuid = agency.LanguageGuid;
            // accountObj.LocationGuid = uuid.NIL;
            // accountObj.AccTypeId = AccountType.Drawing;
            // accountObj.ParentId = ParentAccount.Drawing;
            // accountObj.IsDefault = false;
            // accountObj.IsActorSpecific = false;
            // accountObj.IsLocationSpecific = true;
            // accountObj.IsGroupHeader = false;
            // accountList.push(accountObj);
            //#endregion

            //#region Create Receivable Account
            let accountObj = Object.create(account);
            accountObj = Object.create(account);
            accountObj.State = Object.create(state);

            accountObj.Name = agency.OfficeShortName + ' ' + agency.ReceivableName;
            accountObj.Description = agency.OfficeShortName + ' ' + agency.ReceivableDescription;
            accountObj.Code = agency.OfficeShortName + '_' + agency.ReceivableCode;
            accountObj.LocationAccType = Receivable.LocationAccType;
            accountObj.State.Name = Receivable.State;
            accountObj.LanguageGuid = agency.LanguageGuid;
            accountObj.LocationGuid = uuid.NIL;
            accountObj.AccTypeId = AccountType.AccountReceivable;
            accountObj.ParentId = ParentAccount.AccountReceivable;
            accountObj.IsDefault = false;
            accountObj.IsActorSpecific = false;
            accountObj.IsLocationSpecific = true;
            accountObj.IsGroupHeader = false;
            accountList.push(accountObj);
            //#endregion

            agency.AccountList = accountList;
        });

        return agencyList;
    }

    getClosingPeriod = async (locationGroupGuid) => {
        try {
            let response = await getClosingPeriod(locationGroupGuid);
            return response.data.GetClosingPeriodPage.results;
        } catch (error) {
            console.log('getClosingPeriod error', error);
        }
    }

    //#region Translation Function
    getTranslatingNotTranlatingObj = (inputObj) => {
        let objForTranslation = {};
        let objNotForTranslation = {};

        // Object.assign(inputObj, { 'CapitalName': Capital.Name, 'CapitalCode': Capital.Code, 'CapitalDescription': Capital.Description, 'ReceivableName': Receivable.Name, 'ReceivableCode': Receivable.Code, 'ReceivableDescription': Receivable.Description, 'DrawingName': Drawing.Name, 'DrawingCode': Drawing.Code, 'DrawingDescription': Drawing.Description })

        Object.assign(inputObj, { 'ReceivableName': Receivable.Name, 'ReceivableCode': Receivable.Code, 'ReceivableDescription': Receivable.Description })

        let result = this.createTranslateAndNotTranslatingObj(inputObj);

        objForTranslation = result.translateObj;
        objNotForTranslation = result.notTranslateObj;


        delete objNotForTranslation['LanguageGuid'];

        return { objForTranslation, objNotForTranslation };
    }

    createTranslateAndNotTranslatingObj = (formDataObj) => {
        let translateObj = {};
        let notTranslateObj = {};
        // let translatingItemsArr = ['OfficeName', 'OfficeShortName', 'CapitalName', 'CapitalCode', 'CapitalDescription', 'ReceivableName', 'ReceivableCode', 'ReceivableDescription', 'DrawingName', 'DrawingCode', 'DrawingDescription'];

        let translatingItemsArr = ['OfficeName', 'OfficeShortName', 'ReceivableName', 'ReceivableCode', 'ReceivableDescription'];

        let itemsNotForTranslatin = Object.keys(formDataObj)
            .filter(key => !translatingItemsArr.includes(key));

        itemsNotForTranslatin.forEach(key => {
            if (formDataObj[key] !== undefined) {
                notTranslateObj[key] = formDataObj[key];
            }

            translatingItemsArr.forEach(key => {
                if (formDataObj[key] !== undefined) {
                    translateObj[key] = formDataObj[key];
                }
            });
        });

        return { translateObj, notTranslateObj };
    }

    getAllLanguages = async () => {
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        let response = await getTenantLanguages(tenantGuid);

        if (response.length > 0) {
            let result = response[0].languageGuid;
            if (this.isComponentMounted) {
                this.setState({ languageArr: result });
            }
        }
    }

    getTranslatedObject = (translateObjArr, objNotForTranslation) => {
        let array2 = {};
        let isLoopComplete = 0;
        let multiLanguageTranslatedArr = [];
        let array1 = [];
        let languageArr = [];

        languageArr = this.state.languageArr;

        for (let m = 0; m < languageArr.length; m++) {

            array1 = [];

            for (let r = 0; r < translateObjArr.length; r++) {

                let instance1 = translateObjArr[r];
                let data = instance1.data;
                let key = instance1.key;

                for (let k = 0; k < data.length; k++) {
                    let a = data[k];
                    if (a.languageId.toLowerCase() === languageArr[m].toLowerCase()) {
                        array1.push({ 'data': a, 'key': key });
                    }
                }
            }

            array2[languageArr[m]] = array1;

        }

        for (let b = 0; b < languageArr.length; b++) {
            let y = {};
            let x = array2[languageArr[b]];

            for (let d = 0; d < x.length; d++) {
                let t = x[d];
                let z = t['data'];
                let key1 = t['key'];
                y['LanguageGuid'] = z.languageId.toLowerCase();
                y[key1] = z.translation;
            }

            multiLanguageTranslatedArr.push(Object.assign(y, objNotForTranslation));
            if (b === languageArr.length - 1) {
                isLoopComplete = 1;
            }
        }

        if (isLoopComplete === 1) {
            return multiLanguageTranslatedArr;
        }
    }

    //#endregion


    render() {
        const { t } = this.props;
        const { countryArr, currencyArr } = this.state;
        const locationResult = this.state.locationArr;

        locationResult.forEach((agencyObj) => {
            if (agencyObj.hasOwnProperty('CountryGuid')) {
                let selectedData = countryArr.filter(function (e) {
                    return (e.value.toLowerCase() === agencyObj.CountryGuid.toLowerCase() && e.LanguageGuid.toLowerCase() === agencyObj.LanguageGuid.toLowerCase());
                });
                if (selectedData.length) {
                    Object.assign(agencyObj, { "Country": selectedData[0] });
                }
                else {
                    Object.assign(agencyObj, { "Country": { display: '' } });
                }
            }

            if (agencyObj.hasOwnProperty('CurrencyGuid')) {
                let CurrencySelectedData = currencyArr.filter(function (e) {
                    return (e.value.toLowerCase() === agencyObj.CurrencyGuid.toLowerCase() && e.LanguageGuid.toLowerCase() === agencyObj.LanguageGuid.toLowerCase());
                });

                if (CurrencySelectedData.length) {
                    Object.assign(agencyObj, { "Currency": CurrencySelectedData[0] });
                }
                else {
                    Object.assign(agencyObj, { "Currency": { display: '' } });
                }
            }
        });

        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar  {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="content-sec">

                                    {
                                        this.state.alert_type === MessageType.SUCCESS ? (<SuccessAlert message={this.state.alert_message} />) : null
                                    }

                                    {
                                        this.state.alert_type === MessageType.ERROR ? (<ErrorAlert message={this.state.alert_message} />) : null
                                    }

                                    <Fragment>
                                        <div className="add-location-div">
                                            <div className="location-text">{t('ADD-MORE LOCATIONS')}</div>
                                            <div className="add-new-location" onClick={this.handleModalOpen}><img src={add_box} alt="" /><span>{t('Add New Location')}</span></div>
                                        </div>
                                        {
                                            (this.state.countryArr.length > 0 && this.state.currencyArr.length > 0) ? (
                                                <div className="added-locations">
                                                    {locationResult && locationResult.map((elmt, i) =>
                                                        <div className="box" key={i}>
                                                            <div className="align-box-elmt">
                                                                <h4 className="location">{elmt.OfficeName}</h4>
                                                                <div className="display_flex">
                                                                    <label className="switch">
                                                                        <input type="checkbox" defaultChecked={elmt.IsActive}
                                                                            onChange={(e) => this.activateDeactivateSeletedLocation(e, elmt)} />
                                                                        <span className="slider round">
                                                                        </span>
                                                                    </label>
                                                                    <div className="delete" onClick={(e) => { this.deletedSelectedLocation(e, elmt) }} href="#"><img src={deleteImg} alt="" style={{ cursor: "pointer" }} /></div>
                                                                </div>
                                                            </div>
                                                            <h3 className="place">{elmt.OfficeName}</h3>
                                                            <h5 className="country">{elmt.Country.display} | {elmt.Currency.display} ({elmt.Currency.symbol})</h5>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (<img src={loader} alt="" className="loader" />)
                                        }

                                        <div className="bottom-button">
                                            <button type="button" className="btn btn-secondary" onClick={() => { this.props.history.push('Language') }}>{t('BACK')}</button>
                                            <button type="button" className="btn btn-primary" onClick={this.navigate} >{t('NEXT')}</button>
                                        </div>
                                    </Fragment>

                                    {
                                        (this.state.isLoading) ? (
                                            <img src={loader} alt="" className="loader" />
                                        ) : null
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >

                {/*Modal:- Start Add new location */}
                < Modal
                    isOpen={this.state.isModalOpen}
                    onRequestClose={this.handleModalClose}
                    contentLabel="My dialog"
                    // className="mymodal"
                    // overlayClassName="myoverlay"
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            // backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        },
                        content: {
                            position: 'absolute',
                            top: '0px',
                            left: '40px',
                            right: '40px',
                            bottom: '40px',
                            border: 'none',
                            background: 'none',
                            overflow: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px'
                        }
                    }
                    }
                // closeTimeoutMS={500}
                >
                    {/* <div className="modal1 location1 fade1" > */}
                    < div className="modal-dialog add-new-dialog" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{t('Add New Location')}</h5>
                                <button type="button" className="close" onClick={this.handleModalClose}>
                                    <span><img src={close_black} alt="" /></span>
                                </button>
                            </div>

                            <fieldset disabled={this.state.isLoading}>
                                <form autoComplete="off" onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label htmlFor="">{t('Location Name')}</label>
                                                <input type="text" required className="form-control" name="OfficeName" onChange={this.handleChange} />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="">{t('Short Name')}</label>
                                                <input type="text" required className="form-control" name="OfficeShortName" onChange={this.handleChange} />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="icon" htmlFor="">{t('Country')}</label>
                                                <select id="country" required className="form-control select" name="CountryGuid" onChange={this.handleChange}>
                                                    {this.state.countryArr && this.state.countryArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="icon" htmlFor="">{t('Currency')}</label>
                                                <select id="currency" required className="form-control select" name="CurrencyGuid" onChange={this.handleChange}>
                                                    {this.state.currencyArr && this.state.currencyArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        {/* <div>Learn more</div> */}
                                        <button type="button" onClick={this.handleModalClose} className="btn btn-secondary" data-dismiss="modal"> {t('CANCEL')}</button>
                                        <button type="submit" className="btn btn-primary" disabled={this.state.isLoading}>
                                            {this.state.isLoading && (
                                                <img src={spinner} alt="" className="btn-loader" />
                                            )}
                                            {t('Save')}
                                        </button>
                                    </div>
                                </form>
                            </fieldset>
                        </div>
                    </div >
                    {/* </div> */}
                </Modal >
                {/*Modal:- End Add new location */}

                {/* Modal Start: - Confirmation modal */}
                <Modal
                    isOpen={this.state.isConfirmModalOpen}
                    onRequestClose={this.handleConfirmModalClose}
                    contentLabel="My Confirm dialog"
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        },
                        content: {
                            position: 'unset',
                            top: '0px',
                            left: '40px',
                            right: '40px',
                            bottom: '40px',
                            border: 'none',
                            background: 'none',
                            overflow: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px'
                        }
                    }}>
                    <div className="modal-dialog delete-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{this.state.confirmationTitle}</h5>
                                <button type="button" className="close" onClick={this.handleConfirmModalClose}>
                                    <span><img src={close_black} alt="" /></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5 className="modal-title">{this.state.confirmationMessage}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={this.handleConfirmModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                <button type="submit" disabled={this.state.isLoading} onClick={this.confirmButtonClicked} className="btn btn-primary" >
                                    {this.state.isLoading && (
                                        <img src={spinner} alt="" className="btn-loader" />
                                    )}{t('CONFIRM')}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                {/* Modal End: - Confirmation modal */}
            </main >
        )
    }
};

export default withTranslation()(Location)